const postLeadService = async (formData = {}) => {
    if (!formData.origin_page_id) {
        // If we don't have an origin page id, we want to set it to the current page id or 0 if it doesn't exist
        formData.origin_page_id = window?.page_id || 0;
    }
    return await fetch('/api/leads', {
        method: 'POST',
        headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': window?.Laravel?.csrfToken || '',
        },
        body: JSON.stringify(formData),
    });
};

export default postLeadService;
